import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { GroundPosition, MapViewComponent } from '../../../../shared/map-view/map-view.component';
import {
  drawGroundPosition,
  drawGroundPositionAtGroup,
  getHeight,
  getWidth
} from '../../setup-ground/ground-groups-map/ground-cell';
import * as PIXI from 'pixi.js';

@Component({
  selector: 'app-setup-pigeonhole-map',
  templateUrl: './setup-pigeonhole-map.component.html',
  styleUrls: ['./setup-pigeonhole-map.component.scss']
})
export class SetupPigeonholeMapComponent extends MapViewComponent implements OnInit, OnChanges {

  @Input() map;
  @Input() selectedPositionIds = new Set();
  @Output() positionClicked = new EventEmitter();

  public mouseX;
  public mouseY;
  private hoveredGraphics: PIXI.Container;
  private selectedGraphics: PIXI.Container;

  constructor(
    protected elementRef: ElementRef,
    protected ngZone: NgZone
  ) {
    super(elementRef, ngZone);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedPositionIds?.currentValue) {
      this.selectedPositionIds = changes.selectedPositionIds.currentValue;
      this.drawSelectedPositions(this.map);
    }

    if (!changes.map?.previousValue && changes.map?.currentValue) {
      const gradePositions = this.getMaxCoordinates(changes.map.currentValue);
      const maxWidth = getWidth(gradePositions.positionsX.length);
      const maxHeight = getHeight(gradePositions.positionsY.length);
      this.initMap(maxWidth, maxHeight);
      this.drawMap(changes.map.currentValue);
    } else if (changes.map?.currentValue) {
      this.drawMap(changes.map.currentValue);
    }
  }

  ngOnInit(): void {}

  public drawMap(groundPositions: GroundPosition[]) {
    if (groundPositions) {
      this.drawGrades(groundPositions);
      this.drawDefaultMap(groundPositions);
      this.drawSelectedPositions(groundPositions);
    }
  }

  drawDefaultMap(groundPositions: GroundPosition[]) {
    this.clearContent();
    for (const groundPosition of groundPositions) {
      const elements = drawGroundPosition(groundPosition);
      const area = elements[0];
      area.interactive = true;
      area.cursor = 'pointer';

      area.on('pointerover', () => {
        this.drawHoverHighlight(groundPosition);
      });

      area.on('pointerout', () => {
        this.clearHoverHighlight();
      });

      area.on('pointerdown', () => {
        this.positionClicked.emit(groundPosition);
      });

      for (const e of elements) {
        // @ts-ignore
        this.viewPort.addChild(e);
      }
    }
  }

  private drawHoverHighlight(groundPosition: GroundPosition) {
    this.clearHoverHighlight();
    this.hoveredGraphics = new PIXI.Container();
    const elements = drawGroundPositionAtGroup(groundPosition);
    for (const e of elements) {
      this.hoveredGraphics.addChild(e);
    }
    // @ts-ignore
    this.viewPort.addChild(this.hoveredGraphics);
  }

  private clearHoverHighlight() {
    if (this.hoveredGraphics) {
      this.hoveredGraphics.destroy();
      this.hoveredGraphics = null;
    }
  }

  private drawSelectedPositions(groundPositions: GroundPosition[]) {
    if (!this.viewPort) return;
    if (this.selectedGraphics) {
      this.selectedGraphics.destroy();
    }
    this.selectedGraphics = new PIXI.Container();
    if (groundPositions && groundPositions.length > 0) {
      for (const groundPosition of groundPositions) {
        if (this.selectedPositionIds.has(groundPosition.rfId)) {
          const elements = drawGroundPositionAtGroup(groundPosition);
          for (const e of elements) {
            this.selectedGraphics.addChild(e);
          }
        }
      }
      // @ts-ignore
      this.viewPort.addChild(this.selectedGraphics);
    }
  }

}
